<template>
  <div class="">
    <ZnBreadcrumb></ZnBreadcrumb>
    <div class="main-content">
      <div class="search-type">
        <ul class="clearfix">
          <li>
            <div>
              <img src="../../assets/images/searchIcon.png" alt="" />
              <input
                type="text"
                placeholder="请输入课题组名称"
                v-model="searchData.taskName"
                @keyup.enter ="getLockerSchoolTask"
              />

              <el-button
                class="cursorPointer"
                type="primary"
                size="small"
                @click="getLockerSchoolTask"
              >
                快速查询
              </el-button>
            </div>
            <div class="btn-wrapper">
              <el-button class="cursorPointer" @click="batchEditShared(true)">
                全部开放
              </el-button>

              <el-button
                class="cursorPointer"
                type="primary"
                @click="batchEditShared(false)"
              >
                全部关闭
              </el-button>
            </div>
          </li>
        </ul>
      </div>
      <div class="goods-info">
        <el-table
          :data="lockerSchoolTask"
          :header-cell-style="{
            background: '#F8FAFC',
            color: 'rgba(0, 0, 0, 0.85)',
            fontWeight: 700,
            height: '54px',
          }"
          border
          style="width: 100%"
        >
          <template slot="empty">
            <img src="../../assets/images/empty.png" class="empty" />
            <p>暂无操作记录</p>
          </template>
          <el-table-column prop="" label="序号">
            <template slot-scope="scop">
              {{ scop.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="taskName" label="课题组名称"></el-table-column>
          <el-table-column prop="schoolName" label="所属学校"></el-table-column>
          <el-table-column label="公开状态" :formatter="formatterValue">
            <!--            <template slot-scope="scop" >-->
            <!--              <div v-if="scop.row.sharedTask !=null">-->
            <!--                <div v-if="scop.row.sharedTask.includes(userInfo.taskId)">-->
            <!--                  对他已开放-->
            <!--                </div>-->
            <!--                <div v-else>-->
            <!--                  对他已关闭-->
            <!--                </div>-->
            <!--              </div>-->

            <!--            </template>-->
          </el-table-column>
          <el-table-column label="试剂公开设置">
            <template slot-scope="scop">
              <el-switch
                v-model="scop.row.shared"
                active-text="开放"
                inactive-text="关闭"
                @change="editShared(scop.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="特殊试剂屏蔽设置" :formatter="isShowSetting">
            <template slot-scope="scope">
              <el-link type="primary" @click="settingShielded(scope.row)" v-if="scope.row.shared == true" :underline="false">点击设置</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div style="color: red; font-size: 14px; margin-top: 25px">
          注：开放后对方课题组可以查看本组试剂数据，并能申请借用本组试剂
        </div>
        <Pagination
          style="margin-top: -40px"
          :dataTotal="pagedata.total"
          :totalpage="pagedata.totalpage"
          :pagesize="searchData.pageSize"
          @changePage="changePage"
        ></Pagination>
      </div>
    </div>


    <el-dialog title="试剂屏蔽" :visible.sync="shieldedDataSync" :before-close="closeShieldSync">
      <el-row>
        <el-col>
          <el-button class="cursorPointer" type="primary" size="small" @click="addTansfer">添加试剂</el-button>
        </el-col>
      </el-row>
      <el-table :data="shieldedGridData">
        <template slot="empty">
          <img src="../../assets/images/empty.png" class="empty" />
          <p>暂无数据</p>
        </template>
<!--        <el-table-column property="reagentCode" label="试剂编号"></el-table-column>-->
        <el-table-column property="reagentName" label="试剂名称"></el-table-column>
        <el-table-column property="casNo" label="CAS号"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="middle" type="text" @click="removeShield(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="试剂选择" :visible.sync="transferDataSync" :show-close = "false">
      <div style="height: 580px">
      <span>
        <el-transfer filterable :filter-method="filterMethod" filter-placeholder="请输入CAS号搜索" :button-texts="['移除', '添加']"
                     :titles="['全部试剂', '被屏蔽试剂']" v-model="transferData" :data="transferReagentData"
                     @change="handleChange" ref="shieldedTransfer">
        </el-transfer>
      </span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="transferCancel">取 消</el-button>
        <el-button type="primary" @click="saveTransfer">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shieldedTaskId: null,
      casNoArray: [],
      transferData: [],
      transferReagentData: [],
      transferDataSync: false,
      shieldedDataSync: false,
      shieldedGridData: null,
      searchData: {
        taskName: "",
        pageNum: 1,
        pageSize: 10,
      },
      alias: "",
      pagedata: {
        total: null,
        totalpage: null,
      },
      lockerSchoolTask: [],
      sharedTask: [],
      userInfo: {
        taskId: "",
      },
    };
  },
  created() {
    this.getLockerSchoolTask();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    isShowSetting(row){
      //if(null != row.sh)
    },
    formatterValue(row) {
      if (row.sharedTask == undefined) {
        row.shared = false;
        return "对他已关闭";
      } else {
        if (
          row.sharedTask.findIndex((value) => value == this.userInfo.taskId) !=
          -1
        ) {
          row.shared = true;
          return "对他已开放";
        } else {
          row.shared = false;
          return "对他已关闭";
        }
      }
    },
    removeShield(row){
      const shieldedTaskId = row.shieldedTaskId;
      const casNo = row.casNo;
      this.$confirm("是否确认移除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$apiFetch.post("/reagentShielded/removeShield",{shieldedTaskId: shieldedTaskId,casNo: casNo})
            .then((res) => {
              const id = this.shieldedTaskId;
              this.getShieldedData(id);
            }).catch((error)=> {
        });
      }).catch(() => {
      });
    },
    closeShieldSync(){
      this.shieldedDataSync = false;
      this.shieldedTaskId = null;
    },
    transferCancel(){
      this.transferDataSync = false;
      this.$refs.shieldedTransfer.$refs.leftPanel.checked = [];
      this.$refs.shieldedTransfer.$refs.rightPanel.checked = [];
      if(this.$refs.shieldedTransfer) {
        this.$refs.shieldedTransfer.$children["0"]._data.query = '';
        // 清空右边搜索
        this.$refs.shieldedTransfer.$children["3"]._data.query = '';
      }
      this.transferData = [];
    },
    filterMethod(query, item){
      //query查询参数
      //item数据集合
      return item.casNo.indexOf(query.trim()) > -1;
    },
    saveTransfer(){
      const data = this.casNoArray;
      const id = this.shieldedTaskId;
      this.$apiFetch.post('/reagentShielded/saveTransfer', {casNoArray: data,shieldedTaskId: id}).then((res) => {
        if (!res.data.code) {
          this.$message.success("保存成功");
          this.getShieldedData(id);
          this.transferDataSync = false;
        } else {
          this.$message.error("保存失败 -- " + res.data.description);
        }
      }).catch((error)=> {
      });
    },
    addTansfer(){
      this.transferDataSync = true;
      const id = this.shieldedTaskId;
      this.getReagentData();
      this.getDataChecked(id);
    },
    handleChange(value, direction, movedKeys) {
      this.casNoArray = value;
    },
    getShieldedData(id){
      this.$apiFetch.get('/reagentShielded/getData/'+id).then((res) => {
        this.shieldedGridData = res.data;
      });
    },
    getReagentData(){
      this.$apiFetch.get('/reagentShielded/getReagentData').then((res) => {
        this.transferReagentData = res.data;
      });
    },
    getDataChecked(id){
      this.$apiFetch.get('/reagentShielded/getDataChecked/'+id).then((res) => {
        this.transferData = res.data;
      })
    },
    settingShielded(row){
      this.shieldedDataSync = true;
      this.shieldedTaskId = row.id;
      this.getShieldedData(row.id);
    },
    getLockerSchoolTask() {
      let params = this.searchData;
      // 获取课题组
      this.$apiFetch.get(`/lockerSchoolTask`, params).then((res) => {
        this.lockerSchoolTask = res.data.list;
        this.pagedata = {
          total: res.data.total,
          totalpage: res.data.pages,
        };
      });
    },

    //设置是否公开
    async editShared(row) {
      let params = row;
      const res = await this.$apiFetch.put("lockerSchoolTask", params);
      if (!res.data.code) {
        this.$message.success("修改成功");
      }
      this.getLockerSchoolTask();
    },

    batchEditShared(status) {
      let message = "";
      if (status == true) {
        message = "开放";
      } else {
        message = "关闭";
      }
      this.$confirm("是否全部" + message + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.lockerSchoolTask.map((i) => (i.shared2 = status));
        this.$apiFetch
          .post(`/lockerSchoolTask/batchEditShared`, this.lockerSchoolTask)
          .then((res) => {
            if (res.status == 200) {
              this.$message.success("全部" + message + "成功");
              this.getLockerSchoolTask();
            }
          });
      });
    },

    changePage(data) {
      this.searchData.pageNum = data;
      this.getLockerSchoolTask();
    },
  },
};
</script>
<style lang="less">
.el-transfer-panel__body {
  height: 450px;
}
.el-transfer {
  padding-left:100px;
}
.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
  font-size: 14px;
}
.el-transfer-panel__list.is-filterable {
  height: 430px;
}
//.el-checkbox__inner {
//  display: none;
//  border: 0px;
//}
</style>

<style lang="less" scoped>
.main {
  background-color: #ffffff;
}

.placeDia {
  ul {
    li {
      padding-top: 20px;
      display: flex;

      label {
        display: block;
        color: #666666;
        font-size: 14px;
        width: 25%;
        line-height: 41px;
      }

      input {
        border-bottom: 1px solid #cccccc;
        font-size: 14px;
        line-height: 40px;
        width: 100%;
        color: #333333;
      }

      input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #ccc;
      }

      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #ccc;
      }

      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #ccc;
      }

      input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #ccc;
      }
    }

    li:first-child {
      padding-top: 0;
    }
  }

  .locking {
    width: 100%;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: #478aff;
    border-radius: 4px;
    border: 1px solid #478aff;
    background-color: #ffffff;
    margin-top: 25px;
  }

  span.tips {
    color: #ff4d4f;
    padding-top: 6px;
    text-align: center;
    display: block;
  }
}

/deep/ .el-table {
  margin-top: 20px;
  border-radius: 4px 4px 0 0;

  img.empty {
    width: 196px;
    margin-top: 38px;
  }

  button.forbid {
    color: #ff4d4f;
  }

  span.nomal {
    padding-left: 10px;
  }

  span.disabled {
    padding-left: 10px;
  }

  .nomal::before {
    width: 5px;
    height: 5px;
    background: #52c41a;
    border-radius: 50%;
    content: "";
    position: absolute;
    left: 10px;
    top: 28px;
  }

  span.disabled::before {
    background-color: #ff4d4f;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    content: "";
    position: absolute;
    left: 10px;
    top: 30px;
  }
}

.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;

  ul {
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        width: 14px;
        display: block;
        position: absolute;
        top: 11px;
        left: 9px;
      }

      input {
        margin-right: var(--zng-gap);
        width: 380px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #cccccc;
        padding-left: 28px;
      }

      .btn-wrapper {
      }

      /*  button {
        width: 98px;
        height: 36px;
        background: #478aff;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        margin-left: 12px;
      } */
    }
  }
}

.goods-info {
  padding: 20px;
  background-color: #ffffff;
}

/deep/ .right {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  border-bottom: 1px solid #cccccc;
  display: flex;
  align-items: center;

  .el-input--suffix {
    height: 100%;
  }

  input {
    // height: 20px;
    background-color: #fff;
    border: none;
    padding: 0;
  }

  .el-input__icon {
    line-height: 20px;
  }

  &::placeholder {
    color: #ccc;
  }
}

.requiedText {
  color: red;
}
</style>
